import React, { FunctionComponent } from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"
import infoPanelItems from "./infoPanelItems"
import "./StaticInfoPanel.css"


const StaticInfoPanel: FunctionComponent<{}> = () => {

    return (
        <div className="StaticInfoPanel">
            <OverlayTrigger placement="left" overlay={
                <Popover id="static-info-panel-popover">
                    <Popover.Title id="static-info-panel-popover-title">
                        <div className="StaticInfoPanelPopoverTitle">
                            <p>PTO Information Items</p>
                        </div>
                    </Popover.Title>
                    <Popover.Content id="static-info-panel-popover-content">
                        <div className="StaticInfoPanelPopoverContent">
                            {infoPanelItems.map((item, i) =>
                                <div className="StaticInfoPanelPopoverContentItem">
                                    <p className="StaticInfoPanelPopoverContentItemTitle">
                                        {item.title}
                                    </p>
                                    <p className="StaticInfoPanelPopoverContentItemText">{item.text}</p>
                                </div>
                            )}
                        </div>
                    </Popover.Content>

                </Popover>
            }>
                <span className="material-icons">info</span>
            </OverlayTrigger>
        </div>
    )
}

export default StaticInfoPanel